export enum ChatMessageTargetType {
	Lobby = 'lobby',
	Broadcast = 'broadcast',
}
